<template>
  <div id="App-Details">
    <div  class="social-nav filter-blur-50 border-bottom-white-1-50" >
      <div class="nameContainer" style="width: 100vw">
        <router-link to="/personal" class="d-flex">
          <div class="homeIcon">
            <a><img ref="appImage" src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
          </div>
        </router-link>
        <!--        <div class="arrowIcon">-->
        <!--          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">-->
        <!--        </div>-->
        <!--        <router-link to="/roaming" class="d-flex">-->
        <!--          <div class="bundleTitle">-->
        <!--            {{digiltaTitle}}-->
        <!--          </div>-->
        <!--        </router-link>-->
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <div class="titleName">{{mtnAppName}}</div>
      </div>
      <!--      <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'checkContainer']" >-->
      <!--        <form :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'filterForm']">-->
      <!--          <div class="checkName">{{$t('popularBundles.showResults')}}</div>-->
      <!--          <div class="check">-->
      <!--            <input type="radio" id="pre" name="filter" value="0" checked @change="filter(0)" >-->
      <!--            <label for="pre" class="radioLabel pre">{{$t('popularBundles.PrePaid')}}</label>-->
      <!--          </div>-->
      <!--          <div class="check">-->
      <!--            <input type="radio" id="post" name="filter" value="1" @change="filter(1)" >-->
      <!--            <label for="post" class="radioLabel post">{{$t('popularBundles.PostPaid')}}</label>-->
      <!--          </div>-->
      <!--        </form>-->
      <!--      </div>-->
    </div>
    <div v-if="show && !error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));">
      <Loader />
    </div>
    <Error v-if="error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));"/>
    <div class="mtnRadioContainer" v-if="!show && !error" :class="[this.$lang === 'ar' ? 'right-dir' : '','']">
      <div class="Radiobackground" :class="[this.$lang === 'ar' ? 'leftPosition' : 'rightPosition','']">
        <div class="mainContainer">
          <!--          <div class="mtnBack">-->
          <!--            <router-link to="/">-->
          <!--              <a>-->
          <!--              <img src="../../assets/icons/backArrow.svg" style="cursor: pointer">-->
          <!--              </a>-->
          <!--            </router-link>-->
          <!--          </div>-->
          <div class="mtnRadioText" :class="[this.$lang === 'ar' ? 'rightPadding' : '','']">
            <div class="MTMRadioTitle d-flex">
              <div class="app-icon"> <img :src="appIcon" class="radioIcon"></div>
              <div class="mainTitle" :class="[this.$lang === 'ar' ? 'arabic-bold' : '','']">{{mtnAppName}}</div>
            </div>
            <div class="mtnRadioImageSmall ">
              <img :src="background" class="d-img-sm w-100 radius-28 max-h">
            </div>
            <div class="radioDescription click-address" :class="lang === 'ar' ? 'right-align'  : ''" v-html="description"></div>
            <div class="main-title font-18 mb-3" :class="lang === 'ar' ? 'arabicDir'  : ''" v-if="googleplay !== null">
              <span v-if="this.$lang === 'ar'">
                {{$t('digitalServices.download') + mtnAppName}}
              </span>
              <span v-else>
                {{$t('digitalServices.download') + mtnAppName + $t('digitalServices.app')}}
              </span>
            </div>
            <div  :class="lang === 'ar' ? 'rightButtons'  : ''">
              <div :class="[$store.state.window < 380 && this.$lang === 'ar' ? 'right-dir' : '','buttons']" class="left-dir">
                <v-btn :class="[$store.state.window < 380 ? '' : 'mr-4' ,'flex-center download-btn']"  target="_blank" :href="appstore" v-if="appstore !== null">
                  <img class="icon" src="../../assets/icons/apple.svg">
                  <div>
                    <div class="download" >{{$t('mtnApp.download')}}</div>
                    <div class="site" >iPhone</div>
                  </div>
                </v-btn>
                <v-btn class="flex-center download-btn" :href="base + googleplay" v-if="googleplay !== null">
                  <img class="icon" src="../../assets/icons/google.svg">
                  <div>
                    <div class="download">{{$t('mtnApp.git')}}</div>
                    <div class="site">Android</div>
                  </div>
                </v-btn>
              </div>
            </div>
          </div>
          <div class="mtnRadioImage">
            <img :src="background" class="radioImage">
          </div>
        </div>
        <!--        <div class="yellowButton">-->
        <!--          <additional-info-card/>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
// import AdditionalInfoCard from '../../components/cards/AdditionalInfoCard'
import $ from 'jquery'
import gc from '../../utils/gc'
import AppDetailsRepository from '../../repositories/AppDetailsRepository'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
export default {
  name: 'index',
  components: { Loader, Error },
  data () {
    return {
      lang: this.$lang,
      digitalServices: new AppDetailsRepository(),
      digiltaTitle: this.$t('digitalServices.Title'),
      mtnAppName: '',
      description: '',
      filterType: 0,
      appIcon: '',
      background: '',
      id: '',
      base: gc.baseUrl,
      appstore: '',
      googleplay: '',
      show: true,
      error: false
    }
  },
  mounted () {
    this.getData()
    this.arabic()
    this.arabicRadio()
  },
  created () {
    this.id = this.$route.params.id
    this.$store.state.activeSectionNav = 0
  },
  methods: {
    // getImageSize () {
    //   const image = this.$refs.appImage
    //   const width = image.naturalWidth
    //   const height = image.naturalHeight
    //   if (width > height) {
    //     $('.app-icon').addClass('icon-y')
    //   } else {
    //     $('.app-icon').addClass('icon-x')
    //   }
    // },
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav').css('direction', 'rtl')
        $('.mainContainer').css('direction', 'rtl')
        $('.mtnRadioText').css('text-align', 'right')
        $('.checkName, .titleName, .MTMRadioTitle, .main-title').css('font-family', 'Mtn-arabic-bold')
        $('.arrowIcon, .mtnBack').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.nav-tab .v-tab').css('transform', 'rotateY(180deg)')
        $('.checkContainer, .buttons').css('direction', 'ltr')
        $('.radioLabel').css('font-family', 'Mtn-regular')
        $('.bundleTitle').css('font-family', 'Mtn-arabic-regular')
        $('.Radiobackground').css('background-position-x', 'left')
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    },
    async getData () {
      this.show = true
      try {
        const response = await this.digitalServices.getAppDetails(this.id)
        if (response.status === 200) {
          this.show = false
          this.description = response.data.description
          this.appIcon = this.base + response.data.icon
          this.background = this.base + response.data.background
          this.mtnAppName = response.data.title
          this.appstore = response.data.appleLink
          this.googleplay = response.data.link
          this.fetched = true
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    }
    // filter (val) {
    //   this.filterType = val
    //   this.arabicRadio()
    // }
  }
}
</script>

<style scoped lang="scss">
  @import "src/assets/sass/main";
  .app-icon {
    //width: auto;
    //height: 50px;
    width: 65px;
    height: auto;
    display: flex;
    align-items: center;
  }
  //.icon-x {
  //  width: 65px!important;
  //  height: auto!important;
  //}
  //.icon-y {
  //  width: auto!important;
  //  height: 60px!important;
  //}
  #App-Details{
    padding-top: 160px;
  }
  #App-Details .social-nav{
    //background: rgba(212, 212, 212, 0.45);
    //background-color: $--light-white;
    height: 50px;
    //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
    //backdrop-filter: blur(40px);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }
  .arabicBack{
    right: 4vw;
    left: unset !important;
    transform: rotateY(180deg);
  }
  .arabicSearch{
    right: 0 !important;
    left: unset !important;
  }
  #App-Details .nameContainer{
    display: flex;
    padding: 0 4vw 0 3.2vw;
  }
  #App-Details .homeIcon {
    cursor: pointer;
  }
  .homeIcon,
  .arrowIcon,
  .titleName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  #App-Details .titleName{
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
  }
  #App-Details .bundleTitle{
    width: max-content;
    font-family: Mtn-regular;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .backArrow{
    width: 35px;
    height: 35px;
    margin-bottom: 50px;
  }
  .filterForm{
    display: flex;
  }
  .checkContainer{
    display: flex;
    justify-content: flex-end;
    width: 50vw;
    padding: 0 3vw;
    font-family: Mtn-regular;
  }
  .check{
    padding: 0 2vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .checkName{
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Mtn-bold;
    font-style: italic;
  }
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label
  {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #1D1D1D;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 2.5px solid $--yellow;
    border-radius: 100%;
    background: transparent;
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: '';
    width: 8px;
    height: 8px;
    background: $--yellow;
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    font-weight: bold;
  }
  input[type="radio"]:checked+label {
    font-family: Mtn-bold;
    /*font-family: Mtn-arabic-bold;*/
  }
  @media screen and (max-width: 650px) {
    .checkName {
      display: none;
    }
  }
  @media screen and (max-width: 950px) {
    /*.homeIcon,*/
    /*.arrowIcon,*/
    /*#App-Details.bundleTitle,*/
    /*.checkName{*/
    /*  display: none;*/
    /*}*/
    /*.nameContainer{*/
    /*  width: 40vw !important;*/
    /*}*/
    .checkContainer{
      width: 60vw !important;
    }
  }
  .mtnRadioContainer{
    min-height: calc(100vh - (170px + 277.2px));
    background-image: linear-gradient(to bottom, #F2F2F2, #e1e1e1);
  }
  .Radiobackground{
    min-height: calc(100vh - (170px + 277.2px));
    background-image: url('../../assets/icons/digitalServices.svg');
    /*background-position-x: right;*/
  }
  .mainContainer{
    display: flex;
    position: relative;
  }
  .radioImage{
    width: 100%;
    height: auto;
    //height: 280px;
    //width: 500px;
    border-radius: 28px;
  }
  .mtnRadioText {
    //width: 70%;
    width: 58.33333333%;
    padding: 60px 4vw;
    text-align: left;
  }
  .mtnRadioImage {
    /*width: 40%;*/
    width: 41.66666667%;
    padding: 60px 3vw;
  }
  .arabicDir{
    text-align: right !important;
  }
  .rightButtons{
    display: flex;
    justify-content: right!important;
  }
  .main-title {
    font-style: italic;
  }
  .v-btn {
    text-transform: initial!important;
  }
  .download {
    /*font-size: 10px!important;*/
    font-size: 9px !important;
    color: #1D1D1D;
    font-family: 'Mtn-bold';
  }
  .site {
    color: #1D1D1D;
    font-family: 'Mtn-bold';
    text-align: start;
  }
  .icon {
    margin-right: 7px;
    width: 22px;
  }
  .buttons{
    display: flex;
  }
  .mtnBack{
    position: absolute;
    top: 30px;
    padding: 0 4vw;
  }
  .MTMRadioTitle{
    font-size: 30px;
    color: $--yellow;
    font-family: Mtn-bold;
    padding: 15px 0;
    display: flex; align-items: center;
  }
  .radioIcon{
    height: 100%;
    width: 100%;
    /*width: 44px;*/
    /*height: 52px;*/
    /*min-width: 35px;*/
    /*max-height: 35px;*/
  }
  .radioDescription{
    /*padding: 0 2vw*/
    min-height: 160px;
  }
  .mtnRadioImageSmall{
    display: none;
  }
  @media screen and (max-width: 992px) {
    .mtnRadioImageSmall {
      display: block;
      padding-bottom: 5vh;
      max-width: 484px !important;
    }
    .mtnRadioImage{
      display: none;
    }
    .mtnRadioText {
      width: 100%;
    }
    .radioDescription{
      min-height: unset;
    }
  }
  .yellowButton{
    padding: 50px 2vw;
  }
  @media screen and (max-width: 381px) {
    .buttons {
      display: block;
    }
  }
  #App-Details .theme--light.v-btn.v-btn--has-bg {
    background: transparent !important;
  }
  .mainTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
  }
  .leftPosition {
    background-position-x: left;
  }
  .rightPosition {
    background-position-x: right;
  }
  .rightPadding{
    padding: 60px 5vw !important
  }
</style>
<style>
#App-Details .theme--light.v-btn.v-btn--has-bg, #App-Details .theme--light.v-btn.v-btn--has-bg::before {
  background: transparent !important;
  box-shadow: none!important;
}
</style>
